import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { Scenario } from "../models/scenario";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

const postScenario = async (data: Scenario) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

const usePostScenario = () => {
  return useMutation<unknown, AxiosError, Scenario, unknown>(postScenario);
};

export default usePostScenario;
